import styled from "styled-components";

export const StyledModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: linear-gradient(${(p) => p.theme.bg}, ${(p) => p.theme.bg});
  background-color: ${(p) => p.theme.paperBg};
  box-shadow: 0 5px 10px -5px ${(p) => p.theme.shadow};
  border-radius: 4px;
  position: relative;
  max-width: 100%;
`;

export const StyledModalCloseButton = styled.div`
  cursor: pointer;
`;

export const StyledModalChildren = styled.div`
  width: 100%;
  padding: 20px;
`;

export const StyledModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px 20px 10px;
  box-shadow: 0px 5px 5px -5px ${(p) => p.theme.shadow};
`;

export const StyledModalFooter = styled.div`
  width: 100%;
  display: flex;
  gap: 14px;
  padding: 10px 20px 14px;
  box-shadow: 0px 5px 5px -5px ${(p) => p.theme.shadow};
  justify-content: end;
  & > button {
    flex: 1;
  }
`;

export const StyledModalHeaderText = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  & > :first-child {
    flex: 1;
  }
`;
